export default __webpack_public_path__ + "static/media/ordi.a23bd2bd.png";